import * as actions from "../action.constants";

const cloneProfile = (sourceMac) => ({
  type: actions.CLONE_PROFILE,
  sourceMac,
});

const cloneStarted = (taskId, targetMac) => ({
  type: actions.CLONE_STARTED,
  payload: {taskId, targetMac},
});

const cloneProgressUpdated = (current, total) => ({
  type: actions.CLONE_PROGRESS_UPDATED,
  payload: {current, total},
});

const cloneSensorsReset = () => ({type: actions.CLONE_SENSORS_RESET});

export {cloneProfile, cloneStarted, cloneProgressUpdated, cloneSensorsReset};
